export default __webpack_public_path__ + "assets/Luxury.a088a31b.webp";